import { apiService } from './apiService';

export const staticDefinitionService = {
  async getAll() {
    return apiService.get('/static-definitions');
  },
  async getByKey(key: string) {
    return apiService.get(`/static-definitions/key/${encodeURIComponent(key)}`);
  },
  async createDefinition(data: { key: string; name: string; inputType: string; description?: string }) {
    return apiService.post('/static-definitions', data);
  },
  async updateDefinition(id: string | number, data: { key: string; name: string; inputType: string; description?: string; isActive?: boolean }) {
    return apiService.put(`/static-definitions/${id}`, data);
  },
  async deleteDefinition(id: string | number) {
    return apiService.delete(`/static-definitions/${id}`);
  },
  async createItem(definitionId: string | number, data: { value: string; order?: number; assignmentPriority?: number; vehicleDocumentScope?: string[]; isActive?: boolean }) {
    return apiService.post(`/static-definitions/${definitionId}/items`, data);
  },
  async updateItem(itemId: string | number, data: { value: string; order?: number; assignmentPriority?: number; vehicleDocumentScope?: string[]; isActive?: boolean }) {
    return apiService.put(`/static-definitions/items/${itemId}`, data);
  },
  async deleteItem(itemId: string | number) {
    return apiService.delete(`/static-definitions/items/${itemId}`);
  },
};
